import { render } from "./ProgressNoteTriage.vue?vue&type=template&id=6d2ae406"
import script from "./ProgressNoteTriage.vue?vue&type=script&lang=js"
export * from "./ProgressNoteTriage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__